import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useChatStore } from '../../../shared/store/chatStore';
import { useAuth } from '../../../shared/contexts/AuthContext';
import { websocketService } from '../../../shared/services/websocketService';

export function useChat() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();
    const chatStore = useChatStore();

    useEffect(() => {
        if (id) {
            const loadChatData = async () => {
                console.log('[useChat] Loading chat data for id:', id);
                await chatStore.loadChat(id);
                await chatStore.loadMessages(id);
            };
            loadChatData();
        }
    }, [id]);

    useEffect(() => {
        console.log('[useChat] ID changed, clearing state:', id);
        if (!id) {
            chatStore.clearState();
        }
        return () => {
            if (!window.location.pathname.startsWith('/chat/')) {
                console.log('[useChat] Cleanup - clearing state');
                chatStore.clearState();
            }
        };
    }, [id]);

    const handleSendMessage = async (content: string) => {
        if (!content.trim() || !user) return;

        try {
            if (!id) {
                console.log('[useChat] Creating new chat');
                chatStore.clearState();
                const newChat = await chatStore.createChat(content, user.id);
                if (newChat) {
                    console.log('[useChat] New chat created:', newChat.id);
                    console.log('[useChat] Sending first message');
                    await chatStore.sendMessage(content, newChat.thread_id, newChat.id);
                    console.log('[useChat] Navigating to new chat');
                    navigate(`/chat/${newChat.id}`);
                }
            } else if (chatStore.currentChat) {
                console.log('[useChat] Sending message to existing chat:', id);
                await chatStore.sendMessage(content, chatStore.currentChat.thread_id, id);
            }
        } catch (error) {
            console.error('Error sending message:', error);
        }
    };

    return {
        currentChat: chatStore.currentChat,
        messages: chatStore.messages,
        isLoading: chatStore.isLoading,
        streaming: chatStore.streaming,
        actions: {
            sendMessage: handleSendMessage,
            tellMeMore: chatStore.tellMeMore,
            followUpQuestion: chatStore.followUpQuestion,
            retryLastMessage: chatStore.retryLastMessage
        }
    };
}